<template>
    <app-loader></app-loader>
</template>

<script>
  import App from '../../../../App'
  import AppLoader from '../../../../components/app-loader'
  export default {
    name: 'auth-logout',
    components: {AppLoader, App},
    created () {
      localStorage.removeItem('auth._user')
      this.$auth.logout({
        makeRequest: true,
        redirect: '/login'
      }).catch(() => (this.$router.push('/login')))
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/auth/components/auth-logout.vue